export default __webpack_public_path__ + "static/media/mediumkpmg_logo.f2bfc25a.svg";